(function () {
    'use strict';
    angular.module('servicesModule')
        .controller('AboutFolderModalController', controller);
    controller.$inject = ['$scope', '$http', '$uibModal', '$uibModalInstance', 'model', '$sce'];
    function controller($scope, $http, $uibModal, $modalInstance, model, $sce) {
        var vm = this;
        vm.globalResources = angular.copy(globalResources);
        vm.data = model;
        vm.close = close;
        initialize();

        function initialize() {
        }


        function close() {
            $modalInstance.close(true);
        };

    };
})();